import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

const isRecoveryFlow =
  window.location.pathname === "/reset-password" &&
  window.location.hash.includes("access_token");

// Keep recovery tokens in the URL during password reset so the auth client
// can fully establish the recovery session before the page cleans anything up.
if (!isRecoveryFlow && window.location.hash && window.location.hash.includes("access_token")) {
  setTimeout(() => {
    window.history.replaceState(null, "", window.location.pathname + window.location.search);
  }, 500);
}

createRoot(document.getElementById("root")!).render(<App />);

// Remove LCP placeholder once React has rendered
requestAnimationFrame(() => {
  const ph = document.getElementById("lcp-placeholder");
  if (ph) {
    ph.style.opacity = "0";
    ph.style.transition = "opacity 0.3s";
    setTimeout(() => ph.remove(), 350);
  }
});
